import { render, staticRenderFns } from "./ScorecardItemList.vue?vue&type=template&id=a6576f5a"
import script from "./ScorecardItemList.vue?vue&type=script&lang=js"
export * from "./ScorecardItemList.vue?vue&type=script&lang=js"
import style0 from "./ScorecardItemList.vue?vue&type=style&index=0&id=a6576f5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports